import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import BreadcrumbBar from "./components/BreadcrumbBar";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useLangPath } from "./hooks/useLangPath";
import Seo from "./Seo";

function ForexMinors() {
  const { t } = useTranslation();
  const langPath = useLangPath();

  const pairs = [
    { label: "AUD/JPY", path: "/forex-minors/audjpy-ai-trading-predictions" },
    { label: "AUD/NZD", path: "/forex-minors/audnzd-ai-trading-predictions" },
    { label: "CAD/CHF", path: "/forex-minors/cadchf-ai-trading-predictions" },
    { label: "EUR/CHF", path: "/forex-minors/eurchf-ai-trading-predictions" },
    { label: "AUD/CAD", path: "/forex-minors/audcad-ai-trading-predictions" },
    { label: "GBP/JPY", path: "/forex-minors/gbpjpy-ai-trading-predictions" },
  ];

  return (
    <>
      <Seo
        title={t("forexMinors.pageTitle")}
        description={t("forexMinors.pageDesc")}
        canonical="/forex-minors"
        breadcrumbs={[
          { name: t("common.home"), path: "/" },
          { name: t("nav.forexMinors"), path: "/forex-minors" },
        ]}
      />
      <BreadcrumbBar crumbs={[{ label: t("common.home"), to: langPath("/") }, { label: t("nav.forexMinors") }]} />
      <Container style={{ paddingTop: 24, paddingBottom: 60 }}>
      <h1>{t("forexMinors.h1")}</h1>
      <p style={{ color: "#6c757d", marginBottom: 32 }}>{t("forexMinors.pageDesc")}</p>
      <Row>
        {pairs.map(({ label, path }) => (
          <Col md={4} key={path}>
            <Link to={langPath(path)} className="text-decoration-none">
              <Card className="mb-4"><Card.Body><Card.Title>{label}</Card.Title></Card.Body></Card>
            </Link>
          </Col>
        ))}
      </Row>
      </Container>
    </>
  );
}

export default ForexMinors;
